// @ts-check

const initializeAll = function (e) {
  // window.performance.mark('initialize');
  if (e) {
    // @ts-ignore
    e.target.removeEventListener('DOMContentLoaded', initializeAll)
  }
  // ascolto la prima interazione
  document.body.addEventListener('touchstart', initInteractions)
  window.addEventListener('scroll', initInteractions)
  startReloadTimer()
}

function reloadPage () {
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)

  if (urlParams.has('refresh')) {
    window.location.reload()
  } else {
    let i = 0
    urlParams.forEach((p, idx) => i++)
    if (i === 0) {
      window.location.href = window.location.href + '?refresh'
    } else {
      window.location.href = window.location.href + '&refresh'
    }
  }
}

function startReloadTimer () {
  let live = false
  // @ts-ignore
  const twitchLive = window.twitchLive
  // @ts-ignore
  const currentData = window.currentData
  const splitted = currentData.template.split('/')
  const type = splitted.pop()
  if (twitchLive) {
    live = twitchLive.isLive.live
  }
  if (live || type === 'live.php') {
    const fiveMinutes = 60 * 5 * 1000
    setTimeout(() => {
      reloadPage()
    }, fiveMinutes)
  }
}

/**
   * Alla prima interazione (o al reload della pagina già scrollata)
   * carica app.js e inizializza l'applicazione
   *
   * @param {Event} e
   */
async function initInteractions (e) {
  document.body.removeEventListener('touchstart', initInteractions)
  window.removeEventListener('scroll', initInteractions)

  console.log('init interactions')
  const { init } = await import('./app')
  // window.currentData -> oggetto passato tramite localize_script dal php
  // @ts-ignore
  await init(window.currentData)
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initializeAll()
} else {
  document.addEventListener('DOMContentLoaded', initializeAll)
}
